const HostelOverviewPage = () => {
    return (
        <></>
    );
}

export default HostelOverviewPage;